import React, { Component } from 'react';
import { pathOr } from 'ramda';
import PropTypes from 'prop-types';

import ClassifierFields from 'components/common/fields/ClassifierFields';
import { PersonBlock } from '../fields/PersonBlock';
import { PersonEducations } from '../fields/PersonEducations';
import { PersonLanguages } from '../fields/PersonLanguages';
import { PersonWorkplaces } from '../fields/PersonWorkplaces';
import { PersonLabels } from '../fields/PersonLabels';
import { PersonComments } from '../fields/PersonComments';
import PersonContacts from '../fields/PersonContacts';
import { PersonAddressBlock } from '../fields/PersonAddressBlock';
import { PersonAdditionalBlock } from '../fields/PersonAdditionalBlock';

export default class PersonGeneral extends Component {
    static propTypes = {
        person: PropTypes.object.isRequired,
    }

    render() {
        const { person } = this.props;

        return (
            <div>
                <div className="panel-view">
                    <PersonBlock
                        firstName={person.firstName}
                        lastName={person.lastName}
                        middleName={person.middleName}
                        sex={person.sex}
                        photo={pathOr(false, ['photo', 'body'], person)}
                        birthday={person.bithday}
                    />
                </div>
                <PersonContacts
                    emails={person.email}
                    phone={person.phone}
                    webs={person.web}
                    messengers={person.messenger}
                />
                <PersonWorkplaces workplaces={person.workplace} />
                <PersonEducations list={person.education} />
                <PersonAddressBlock address={person.address} />
                <PersonLanguages list={person.language} />
                <ClassifierFields classifiers={person.classifier} />
                <PersonComments comments={person.comment} />
                <PersonLabels labels={person.labels} />
                <PersonAdditionalBlock
                    citizenship={person.citizenship}
                    sourceForSys={person.sourceForSys}
                />
            </div>
        );
    }
}
